import { IRequestService } from '..';
import { WorkflowDTO } from '../../models/DTO/WorkflowDTO';

export interface IWorkflowService {
    getOverview(): angular.IPromise<WorkflowDTO[]>;
}

export class WorkflowService implements IWorkflowService {
    static serviceId = 'workflowService';

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }


    getOverview(): angular.IPromise<WorkflowDTO[]> {
        this._requestService.cleanCacheAtV1('workflow/overview');
        return this._requestService.getAtV1<WorkflowDTO[]>('workflow/overview');
    }
}